/**
 * Describes the types of triggers for a zoom change event
 *
 * @enum {string}
 */
export default {
  UNSET: '',
  API: 'api',
  USER: 'user'
};
